(function() {
  const currYear = document.querySelector('.js-curr-year');
  const currDate = new Date();
  currYear.innerText = currDate.getFullYear();
})();